var map = {
	"./btn_breast_off.svg": "332e",
	"./btn_breast_on.svg": "9f6e",
	"./btn_colorectal_off.svg": "581d",
	"./btn_colorectal_on.svg": "de38",
	"./btn_dementia_off.svg": "18b6",
	"./btn_dementia_on.svg": "ed95",
	"./btn_dm_off.svg": "18e2",
	"./btn_dm_on.svg": "dbe9",
	"./btn_heart_off.svg": "6ed7",
	"./btn_heart_on.svg": "a5e3",
	"./btn_liver_off.svg": "8eee",
	"./btn_liver_on.svg": "ef4c",
	"./btn_lung_off.svg": "b277",
	"./btn_lung_on.svg": "bf3b",
	"./btn_prostate_off.svg": "97d6",
	"./btn_prostate_on.svg": "179c",
	"./btn_stomach_off.svg": "7a5e",
	"./btn_stomach_on.svg": "0b6b",
	"./btn_stroke_off.svg": "26f0",
	"./btn_stroke_on.svg": "bb8c",
	"./face_caution.svg": "1b22",
	"./face_highrisk.svg": "f6fa",
	"./face_normal.svg": "12b5",
	"./face_risk.svg": "4c6c",
	"./footer_facebook.svg": "34cc",
	"./menu_chart_off.svg": "69e1",
	"./menu_chart_on.svg": "7389",
	"./menu_logo.svg": "1908",
	"./menu_logo_mirai.svg": "9096",
	"./menu_note_off.svg": "5902",
	"./menu_note_on.svg": "fed6",
	"./menu_setting_off.svg": "b9c6",
	"./menu_setting_on.svg": "695a",
	"./menu_user_off.svg": "3915",
	"./menu_user_on.svg": "8c9c",
	"./panel_caution.svg": "3627",
	"./panel_caution_off.svg": "89d5",
	"./panel_highrisk.svg": "7b71",
	"./panel_highrisk_off.svg": "c7a4",
	"./panel_normal.svg": "76f4",
	"./panel_normal_off.svg": "f326",
	"./panel_risk.svg": "2bed",
	"./panel_risk_off.svg": "75e0",
	"./poweredbyselvy.svg": "d17b",
	"./sample.svg": "3674",
	"./stamp_bad_off.svg": "b919",
	"./stamp_bad_on.svg": "104a",
	"./stamp_drag_off.svg": "bb29",
	"./stamp_drag_on.svg": "b0df",
	"./stamp_drink_off.svg": "68b2",
	"./stamp_drink_on.svg": "6854",
	"./stamp_exercise_off.svg": "d156",
	"./stamp_exercise_on.svg": "1b66",
	"./stamp_good_off.svg": "1011",
	"./stamp_good_on.svg": "f5dc",
	"./stamp_toilet_off.svg": "f907",
	"./stamp_toilet_on.svg": "8c1c",
	"./top_logo.svg": "4f76"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "25d8";